

import React, { Component } from 'react';

class MissionsWeSupport extends Component {
  render() {
    return (
      <section>
        <header id="page-title">
          <div className="container">
            <h1>Missions We Support</h1>
          </div>
        </header>
        <section className="container">

          <p className="lead">CRCK is committed to seeing the good news of Jesus spread not only in our own backyard but also around our state, country and the world.</p>

          <p className="lead">CRCK supports five mission partners, locally and abroad, both financially and in prayer:</p>

          <ul style={{ listStyleType: "none" }}>
            <li><strong>University Fellowship of Christians</strong><br />
              A student society at the University of Tasmania committed to sharing the gospel on campus: <a href="http://www.ufcutas.org" target="_blank" rel="noopener noreferrer">www.ufcutas.org</a></li>
            <br />
            <li><strong>Derek and Anna Brotherson</strong><br />
              Theological educators in South East Asia: <a href="mailto:derekandanna@gmail.com">derekandanna@gmail.com</a></li>
            <br />
            <li><strong>Crossroads Prison Ministries</strong><br />
              Crossroads connects prisoners with mentors in Christ-centered relationships so that lives, prisons and churches are restored through the Gospel. <a href="https://www.crossroadspm.org.au/" target="_blank" rel="noopener noreferrer">www.crossroadspm.org.au/</a></li>
            <br />
            <li><strong>G.O.S.P.E.L.</strong><br />
              Indigenous church-planting in India: <a href="http://www.crca.org.au/our-ministries/grow" target="_blank" rel="noopener noreferrer">www.crca.org.au/our-ministries/grow</a></li>
            <br />
            <li><strong>SWIM</strong><br />
              Theological education and practical care in the Solomon Islands: <a href="http://swim.crca.org.au/" target="_blank" rel="noopener noreferrer">swim.crca.org.au</a></li>
          </ul>
        </section>
      </section>
    );
  }
}

export default MissionsWeSupport;
